import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface Props {
  readonly width?: number;
  readonly height?: number;

  /**
   * If set, overrides the logo color.  Accepts any valid SVG color string.
   */
  readonly fill?: string;

  readonly viewBox?: string;
  readonly onClick?: any;
  readonly sx?: SxProps<Theme>;
}

/**
 * This component renders the SVG logo of Paragon Component Systems, LLC.
 */
export function ParaLogo({ width, height, fill = '#F4D367', viewBox = '0 0 32 32', onClick, sx }: Props) {
  const dString =
    'm.24 23.33 6.92-6.92 6.92 6.92H.24zM15.14 22.27l-6.92-6.92 6.92-6.92v13.84zM31.55 23.33l-6.93-6.92-6.92 6.92h13.85zM16.64 22.27l6.92-6.92-6.92-6.92v13.84z';
  return (
    <Box
      component="svg"
      onClick={onClick}
      sx={[
        {
          width,
          height,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
      aria-labelledby="title"
    >
      <title id="paragon-logo">Paragon Logo</title>
      <path fill={fill} d={dString} />
    </Box>
  );
}
